export default __webpack_public_path__ + "static/5-a4dfb2afdb445e4b80d4cf23b06d0997.jpg";